import { Scale } from "lucide-react";

/**
 * Scales-of-Justice emblem. Mandatory center-top on every page.
 */
export default function JusticeEmblem({ size = "md" }) {
  const outer = size === "lg" ? "h-14 w-14" : size === "sm" ? "h-8 w-8" : "h-12 w-12";
  const inner = size === "lg" ? "h-8 w-8" : size === "sm" ? "h-4 w-4" : "h-6 w-6";
  return (
    <div
      data-testid="justice-emblem"
      className="flex items-center justify-center"
      aria-label="IOCRI Scales of Justice Emblem"
    >
      <div className={`relative flex items-center justify-center rounded-full border border-gold/40 bg-black/60 shadow-[0_0_30px_-8px_rgba(212,175,55,0.55)] ${outer}`}>
        <Scale className={`${inner} text-gold`} strokeWidth={1.4} />
      </div>
    </div>
  );
}
